import { useEffect } from 'react';
import { useAuthSession } from '@/api';
import { connectPlayerSocket, disconnectPlayerSocket } from './player-socket';

/**
 * Keeps the UsersAPI `PlayerSocket` connected while a player session is active.
 * Mount once near the app root (e.g. AppShell).
 */
export function usePlayerSocket(): void {
  const { loggedIn, user } = useAuthSession();
  const machineGuid = typeof user?.Guid === 'string' ? user.Guid : null;

  useEffect(() => {
    if (!loggedIn || !machineGuid) {
      disconnectPlayerSocket();
      return;
    }

    connectPlayerSocket(machineGuid);

    return () => {
      disconnectPlayerSocket();
    };
  }, [loggedIn, machineGuid]);
}
